function Logo({ size = 'lg' }) {
  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
  };

  return (
    <div className="flex items-center gap-2">
      <div className="w-8 h-8 rounded-lg bg-gradient-cta flex items-center justify-center">
        <span className="text-white font-bold text-xs">QCO</span>
      </div>
      <span className={`font-display font-bold ${textSizes[size]} text-secondary hidden sm:inline`}>
        QuantoCustaObra
      </span>
    </div>
  );
}

export default Logo;
